// File: ./src/js/modules/coop-search-popover.js

import { Popover } from "../bootstrap";

export default function initCoopSearchPopover(selector = ".coop-search-form__help") {
    const popoverLinks = document.querySelectorAll(selector);

    if (!popoverLinks.length) {
        return;
    }

    const closePopover = (popoverLink) => {
        const popover = Popover.getInstance(popoverLink);

        if (!popover) {
            return;
        }

        popover.hide();
        popoverLink.setAttribute("aria-expanded", "false");
    };

    const closeOtherPopovers = (currentPopoverLink) => {
        popoverLinks.forEach((popoverLink) => {
            if (popoverLink !== currentPopoverLink) {
                closePopover(popoverLink);
            }
        });
    };

    popoverLinks.forEach((popoverLink) => {
        const popover = new Popover(popoverLink, {
            container: "body",
            trigger: "manual",
        });

        popoverLink.addEventListener("shown.bs.popover", () => {
            popoverLink.setAttribute("aria-expanded", "true");
        });

        popoverLink.addEventListener("hidden.bs.popover", () => {
            popoverLink.setAttribute("aria-expanded", "false");
        });

        popoverLink.addEventListener("click", (event) => {
            if (popoverLink.getAttribute("href")?.startsWith("#")) {
                event.preventDefault();
            }

            closeOtherPopovers(popoverLink);
            popover.toggle();
        });

        popoverLink.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
                closePopover(popoverLink);
                popoverLink.focus();
                return;
            }

            if (event.key === " ") {
                event.preventDefault();
                popoverLink.click();
            }
        });

        document.addEventListener("click", (event) => {
            if (popoverLink.contains(event.target)) {
                return;
            }

            closePopover(popoverLink);
        });

        window.addEventListener("blur", () => {
            closePopover(popoverLink);
        });
    });
}
